import React from 'react';
import { GIORNI_BREVI, oraInMinuti, toDateKey } from '../../lib/format';
import { consultabile, fasceOrarie, labelGiorno, minutesToTime, posizioneFascia } from './availability';

/**
 * Vista settimanale del calendario: le ore in verticale, i sette giorni in
 * colonna, le occupazioni disegnate alla loro altezza. Dice quello che il
 * mese non puo' dire — a che ora la sala e' presa — senza aprire un giorno
 * alla volta.
 *
 * La griglia copre l'orario della sala, non le ventiquattr'ore: fuori da
 * quello non c'e' niente da prenotare e sarebbero due terzi di vuoto.
 *
 * Ogni colonna e' il tasto del suo giorno e apre lo stesso modale del mese:
 * la prenotazione resta una sola strada, qui cambia solo il modo di guardare.
 */
export default function CalendarioSettimana({
    giorni, analisi, sala, oggi, giorno, loading, onApri
}) {
    const { base, fine, ore } = fasceOrarie(
        oraInMinuti(sala.orario_apertura),
        oraInMinuti(sala.orario_chiusura)
    );
    const archi = fine - base;

    /* L'altezza di un'ora la fissa il CSS: qui si dice solo quante ore sono,
       cosi' le righe di sfondo e i blocchi restano d'accordo. */
    const misure = { '--lv-week-ore': archi };

    return (
        <div className={`lv-week${loading ? ' is-loading' : ''}`} style={misure}>
            <div className="lv-week-corner" />
            {giorni.map(data => {
                const key = toDateKey(data);
                const classi = [
                    'lv-week-head',
                    key === oggi ? 'is-today' : '',
                    giorno === key ? 'is-selected' : ''
                ].filter(Boolean).join(' ');
                return (
                    <div key={key} className={classi}>
                        <span className="lv-week-dow">{GIORNI_BREVI[(data.getDay() + 6) % 7]}</span>
                        <span className="lv-week-num">{data.getDate()}</span>
                    </div>
                );
            })}

            <div className="lv-week-hours">
                {ore.map(h => (
                    <span
                        key={h}
                        className="lv-week-hour"
                        style={{ top: `${((h - base) / archi) * 100}%` }}
                    >
                        {minutesToTime(h * 60)}
                    </span>
                ))}
            </div>

            {giorni.map(data => {
                const key = toDateKey(data);
                const info = analisi[key];
                // come nel mese
                const siConsulta = consultabile(info, oggi);
                const classi = [
                    'lv-week-col',
                    info ? `is-${info.stato}` : '',
                    giorno === key ? 'is-selected' : '',
                    key === oggi ? 'is-today' : ''
                ].filter(Boolean).join(' ');

                return (
                    <button
                        key={key}
                        type="button"
                        className={classi}
                        title={labelGiorno(key)}
                        disabled={!info || (!info.prenotabile && !siConsulta)}
                        onClick={() => onApri(key)}
                    >
                        {(info ? info.occupate : []).map((o, i) => {
                            const dove = posizioneFascia(o.da, o.a, base, fine);
                            if (!dove) return null;
                            const tipo = o.tipo === 'blocco' ? ' is-block' : (o.mia ? ' is-mine' : '');
                            return (
                                <span
                                    key={i}
                                    className={`lv-week-slot${tipo}`}
                                    style={{ top: `${dove.top}%`, height: `${dove.altezza}%` }}
                                >
                                    <span className="lv-week-slot-time">
                                        {`${minutesToTime(o.da)} – ${minutesToTime(o.a)}`}
                                    </span>
                                    <span className="lv-week-slot-note">{o.titolo}</span>
                                </span>
                            );
                        })}
                    </button>
                );
            })}
        </div>
    );
}
